import { Typography } from "antd";
import { Button, List, Switch } from "antd-mobile";
import { FC } from "react";
import { styled } from "styled-components";
import { BusinessUnit } from "../../redux/apis/blenderApi";

interface IProps {
  businessUnits: BusinessUnit[];
  justLoggedIn: boolean;
  onBusinessUnitSelect(businessUnitId: string, checked: boolean): void;
  onSaveBusinessUnits(): void;
}

const { Title } = Typography;

const BusinessUnitList: FC<IProps> = ({ businessUnits, justLoggedIn, onBusinessUnitSelect, onSaveBusinessUnits }) => {
  return (
    <BusinessUnitsContainer>
      <StyledList header="My Business Units" mode="card">
        {
          businessUnits.length === 0
            ? <Title level={5}>You do not have any business units.</Title>
            : businessUnits.map(bU => (
                <List.Item
                  key={bU.id}
                  arrowIcon={false}
                  extra={<Switch
                    checked={bU.enabled}
                    onChange={checked => onBusinessUnitSelect(bU.id, checked ? true : false)}
                  />}
                  style={{ maxWidth: "100%" }}
                >
                  {bU.name}
                </List.Item>
              ))
        }
      </StyledList>
      <Button onClick={onSaveBusinessUnits} color="primary">{businessUnits.length === 0 ? "OK" : justLoggedIn ? "Start working" : "Done"}</Button>
    </BusinessUnitsContainer>
  );
};

export default BusinessUnitList;

const StyledList = styled(List)`
  max-height: 230px;
  overflow: auto;

  .adm-list-header {
    font-size: ${p => p.theme.fontSizeHeading4}px;
    color: ${p => p.theme.colorText};
    font-weight: 600;
    text-align: center;
    padding: ${p => p.theme.paddingMD}px;
  }
`;

const BusinessUnitsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${p => p.theme.padding}px;
  background-color: ${p => p.theme.colorBgContainer};
  padding: ${p => p.theme.padding}px;
  border-radius: ${p => p.theme.borderRadius}px;
  box-shadow: ${p => p.theme.boxShadow};
`;
